import {Component, DoCheck, KeyValueDiffers, OnInit} from '@angular/core';
import {PdfService} from '../../_services/api/pdf.service';
import {BrowseDocuments, Document, DocumentsStats} from '../../models/browseDocuments.model';
import {DocTypeToken, FileService} from '../../_services/api/file.service';
import {ConfirmationDialogComponent} from '../shared/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {LoadingDialogComponent} from '../shared/loading-dialog/loading-dialog.component';
import {saveAs} from 'file-saver';
import {WebSocketSubject} from 'rxjs/webSocket';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {CreateShareFilesDialogComponent} from '../shared/create-share-files-dialog/create-share-files-dialog.component';
import {itemAnimation, listAnimation} from '../../_animations/listItem';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-browse-files',
  templateUrl: './browse-files.component.html',
  styleUrls: ['./browse-files.component.scss'],
  animations: [listAnimation, itemAnimation]
})
export class BrowseFilesComponent implements OnInit, DoCheck {
  label: string;
  loading: boolean;
  firstLoading = true;
  documents: BrowseDocuments;

  documentsDifferMap = new Map<string, any>();
  documentsMap = new Map<string, Document>();

  selectedType = 'all';
  browseDocumentsType: string[] = [];

  anonymizationStatusWebSocket: WebSocketSubject<any>;

  selectionMode = false;
  isAllSelected = false;
  canBeDownload = true;
  currentlySelected: number;

  constructor(private pdfService: PdfService,
              private fileService: FileService, private snackBar: MatSnackBar,
              private dialog: MatDialog, private kvDiffers: KeyValueDiffers) { }

  getFiles() {
    this.fileService.get('all').subscribe(
      response => {
        this.loading = false;
        if (response.stats !== undefined) {
          this.documents = response;
          this.documents.documents.forEach(doc => {
            this.documentsDifferMap[doc.docId] = this.kvDiffers.find(doc.selection).create();
            this.documentsMap[doc.docId] = doc.selection;
          });
          this.browseDocumentsType = [...new Set(response.documents.map((x) => { return x.type }))];
          // this.startSelectionMode();
          this.firstLoading = false;
        }
      }
    );
  }

  ngOnInit(): void {
    this.label = 'Loading data...';
    this.loading = true;
    this.getFiles();
    this.currentlySelected = 0;
  }

  getSelectedDocs(docs, mustSelected) {
    const docIds: DocTypeToken[] = [];
    docs.forEach(
      doc => {
        if (doc.selection.isSelected || !mustSelected) {
          const index = docIds.findIndex(x => x.type === doc.type);
          if (index >= 0) {
            docIds[index].tokens.push(doc.docId);
          } else {
            docIds.push({tokens: [doc.docId], type: doc.type});
          }
        }
      }
    );
    return docIds;
  }

  selectType(newVal) {
    this.selectedType = newVal.toLowerCase();
    this.calculateStats();
    this.markSelection();
  }

  deleteItem(item: Document) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm deleting the file',
        message: 'Are you sure, you want to remove the file: ' + item.name + ' ?',
        confirm: 'Delete'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.fileService.delete(item.type, item.docId).subscribe( res => {
          if (res.status === 'success') {
            this.documents.documents = this.documents.documents.filter(obj => obj.docId !== item.docId);
            this.calculateStats();
          }
        });
      }
    });
  }

  calculateStats() {
    const stats = new DocumentsStats(0, 0);
    this.documents.documents.forEach(
      (doc: Document) => {
        if ( this.selectedType === 'all' || this.selectedType === doc.type ) {
          stats.filesAmount += 1;
          stats.size += doc.size;
        }
      }
    );
    this.documents.stats = stats;
  }


  startSelectionMode(): void {
    this.selectionMode = true;
    this.documents.documents.forEach( document => {
      document.selection.selectionMode = true;
    });
  }

  endSelectionMode(): void {
    this.selectionMode = false;
    this.documents.documents.forEach( document => {
      document.selection.selectionMode = false;
      document.selection.isSelected = false;
    });
  }

  selectAll(): void {
    let toSet = true;
    let docs = [];
    if (this.selectedType === 'all') {
      docs = this.documents.documents;
    } else {
      docs = this.documents.documents.filter( doc => doc.type === this.selectedType);
    }

    if (docs.every(item => item.selection.isSelected)) {
      toSet = false;
    }

    this.documents.documents.forEach( document => {
      if (this.selectedType === 'all' || this.selectedType === document.type) {
        document.selection.isSelected = toSet;
      }
    });
  }

  deleteSelected(): void {
    if (this.currentlySelected > 0) {
      const message = 'Are you sure, you want to remove selected files?';
      const docIdsArray = [];
      this.documents.documents.forEach(
        doc => {
          if (doc.selection.isSelected) {
            docIdsArray.push(doc.docId);
          }
        }
      );

      const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirm deleting set of documents',
          message,
          confirm: 'Delete'
        }
      });
      confirmDialog.afterClosed().subscribe(result => {
        if (result === true) {

          const loadingDialog = this.dialog.open(LoadingDialogComponent, {
            data: {
              loaderType: 'deleting-file',
              label: 'Deleting files'
            }, disableClose: true
          });

          this.fileService.delete_files(docIdsArray).subscribe(res => {
            loadingDialog.close();
            if (res.status === 'success') {
              this.documents.documents = this.documents.documents.filter(obj => obj.selection.isSelected === false);
              this.unMarkAll();
              this.markSelection();
              this.calculateStats();
            }
          });
        }
      });
    }
  }

  downloadSelected(): void {
    if (this.currentlySelected > 0) {
      const docIds: DocTypeToken[] = this.getSelectedDocs(this.documents.documents, true);
      this.downloadService(docIds);
    }
  }


  downloadService(docIds: DocTypeToken[]) {
      const queueId = Math.random().toString(36).slice(2, 7);
      const confirmDialog = this.dialog.open(LoadingDialogComponent, {
        data: {
            loaderType: 'file-packing',
            label: 'Preparing your files',
            status: 0, queueId
          }, disableClose: true
      });

      this.fileService.download(docIds, queueId).subscribe((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.DownloadProgress:
              confirmDialog.componentInstance.data.label = 'Downloading...';
              confirmDialog.componentInstance.data.status = (event.loaded / event.total) * 100;
              break;
            case HttpEventType.Response:
              const response = event.body;
              const blob = new Blob([response], {
                type: response.type
              });
              let filename = '';
              if (response.type === 'application/x-zip-compressed') {
                filename = this.fileService.getFileName();
                if (docIds.length === 1) {
                  if (docIds[0].type === 'dicom' && docIds[0].tokens.length === 1){
                    filename = this.documents.documents.filter( item => item.docId === docIds[0].tokens[0])[0].name + '-' + this.fileService.getFileName()
                  }
                }
              } else {
                const doc = this.documents.documents.filter(item => item.docId === docIds[0].tokens[0]);
                filename = doc[0].name;
              }
              saveAs(blob, filename);
              confirmDialog.close();
              this.endSelectionMode();
          }
        }, error => {
          this.snackBar.open('Error on downloading.', 'close', {
            duration: 2000,
          });
          confirmDialog.close();
        },
          () => {
            confirmDialog.close();
        });
  }

  markSelection() {
    this.isAllSelected = false;
    this.canBeDownload = true;
    this.currentlySelected = 0;
    if (this.documents !== undefined) {
      let allMark = true;
      this.documents.documents.forEach(
        doc => {
          if (this.selectedType === 'all' || this.selectedType === doc.type) {
            if (!doc.selection.isSelected) {
              allMark = false;
            } else {
              this.currentlySelected += 1;
              if (doc.status !== 'anonymised') {
                this.canBeDownload = false;
              }
            }
          } else {
            doc.selection.isSelected = false;
          }
        }
      );
      if (allMark) {
        this.isAllSelected = true;
      }
    }
  }

  ngDoCheck() {
    for (const key of Object.keys(this.documentsDifferMap)) {
      const docChanges = this.documentsDifferMap[key].diff(this.documentsMap[key]);
      if (docChanges) {
        this.markSelection();
      }
    }
  }

  unMarkAll() {
    this.documents.documents.forEach( document => {
      document.selection.isSelected = false;
    });
  }

  openShareDialogForOneDocument(doc: Document) {
    const docIds: DocTypeToken = {type: doc.type, tokens: [doc.docId]};
    this.openShareDialogBox([docIds]);
  }

  openShareDialogBox(docIds: DocTypeToken[]) {
    const createShareFileDialog = this.dialog.open(CreateShareFilesDialogComponent, {
      data: {
        docIds: docIds
      },
      width: '90%',
      maxWidth: '635px',
    });

    createShareFileDialog.afterClosed().subscribe(result => {
      if (result) {
        this.unMarkAll();
      }
    });
  }

  handleAction(name: string) {
    if (name === 'clearSelection') {
      this.unMarkAll();
    } else if (name === 'downloadSelection') {
      this.downloadSelected();
    } else if (name === 'deleteSelection') {
      this.deleteSelected();
    } else if (name === 'selectAll') {
      this.selectAll();
    } else if (name === 'share') {
      const docIds: DocTypeToken[] = this.getSelectedDocs(this.documents.documents, true);
      this.openShareDialogBox(docIds);
    }
  }

}
